module.exports = __webpack_public_path__ + "static/media/photo-1200.21dd4776.png";